import React, { useState, useEffect } from "react";
import "./brochure-form1.css";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function BrochureForm1({ onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [displayText, setDisplayText] = useState('');
  const fullTitle = "DOCUMENT ACCESS: BROCHURE FORM";

  useEffect(() => {
    let i = 0;
    const timer = setInterval(() => {
      setDisplayText(fullTitle.substring(0, i));
      i++;
      if (i > fullTitle.length) clearInterval(timer);
    }, 50);
    return () => clearInterval(timer);
  }, []);

  const calculateProgress = () => {
    const filledFields = Object.values(formData).filter(val => val !== '').length;
    return Math.round((filledFields / 3) * 100);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(`${API_URL}/brochure-data`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setIsSubmitted(true);
        const link = document.createElement("a");
link.href = "/pdf/TIMSCDR BROCHURE (1)_compressed.pdf";

link.download = "TIMSCDR_BROCHURE.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => onClose(), 3000);
      } else {
        alert("TRANSMISSION FAILED");
      }
    } catch (error) {
      alert("NETWORK ERROR");
    }
    setIsSubmitting(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("tf-portal-container")) {
      onClose();
    }
  };

  const progress = calculateProgress();

  if (isSubmitted) {
    return (
      <div className="tf-portal-container">
        <div className="tf-moving-grid"></div>
        <div className="tf-scanlines"></div>
        <div className="tf-glass-frame tf-success-frame">
          <div className="tf-success-content">
            <div className="tf-success-icon">✓</div>
            <div className="tf-success-title">TRANSMISSION COMPLETE</div>
            <div className="tf-success-message">Thank you! Your form has been submitted successfully.</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tf-portal-container" onClick={handleOverlayClick}>
      <div className="tf-moving-grid"></div>
      <div className="tf-scanlines"></div>
      
      <div className={`tf-glass-frame ${isSubmitting ? 'tf-syncing' : ''}`}>
        
        <div className="tf-progress-container">
          <div className="tf-progress-label">
            <span>ENCRYPTION: {progress}%</span>
            <span>{progress === 100 ? 'DOWNLOAD_READY' : 'PROCESSING...'}</span>
          </div>
          <div className="tf-progress-bar-bg">
            <div className="tf-progress-fill" style={{ width: `${progress}%` }}></div>
          </div>
        </div>

        <div className="tf-header-wrapper">
          <span className="tf-main-title">
            {displayText}
            <span className="tf-cursor">_</span>
          </span>
          <span className="tf-sub-title">* INITIALIZING SECURE DOCUMENT TRANSFER...</span>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="tf-grid-layout">
            <div className="tf-input-group">
              <span className="tf-label">USER IDENTITY</span>
              <input
                name="name"
                type="text"
                placeholder="FULL NAME"
                className="tf-field-input"
                onChange={handleChange}
                value={formData.name}
                required
              />
            </div>

            <div className="tf-input-group">
              <span className="tf-label">EMAIL UPLINK</span>
              <input
                name="email"
                type="email"
                placeholder="EMAIL ADDRESS"
                className="tf-field-input"
                onChange={handleChange}
                value={formData.email}
                required
              />
            </div>

            <div className="tf-input-group" style={{ gridColumn: '1 / -1' }}>
              <span className="tf-label">PHONE UPLINK</span>
              <input
                name="phone"
                type="tel"
                placeholder="PHONE NUMBER"
                className="tf-field-input"
                onChange={handleChange}
                value={formData.phone}
                required
              />
            </div>
          </div>

          <div className="tf-button-cluster">
            <button className="tf-btn-submit tf-glitch-hover" type="submit" disabled={isSubmitting}>
              <span className="tf-btn-text">{isSubmitting ? "DOWNLOADING..." : "[ DOWNLOAD ]"}</span>
            </button>
            <button className="tf-btn-cancel" type="button" onClick={onClose}>
              <span className="tf-btn-text">[ ABORT ]</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default BrochureForm1;
